import fetchWithAuth from "../middlewares/fetchWithAuth";
import { API_BASE_URL } from "../config";

const API_URL = API_BASE_URL;
// "http://localhost:8000";

// Función para obtener las jornadas
export const getInformeRival = async (datos, navigate) => {
  const modernEdition = datos.edition === "modern";
  const pathParams = [
    datos.idTemporada,
    datos.idCompeticion,
    datos.idGrupo,
    datos.idEstadisticasEquipo,
    datos.equipo,
    datos.idPartido,
    datos.idJornada,
  ].map((value) => encodeURIComponent(String(value)));
  const reportUrl = `${API_URL}/reports/informeRival/${pathParams.join("/")}`;
  let response = await fetchWithAuth(
    reportUrl,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        jugadoresDestacados: datos.jugadoresDestacados || [],
        arbitro: datos.arbitro || null,
        ...(modernEdition ? { edition: "modern",
          ...(datos.advancedScope ? { advancedScope: datos.advancedScope } : {}),
          ...(datos.advancedPeriod ? { advancedPeriod: datos.advancedPeriod } : {}) } : {}),
      }),
    },
    navigate
  );

  const contentType = response.headers?.get?.("content-type") || "";
  if (
    !modernEdition && !response.ok &&
    (response.status === 404 || response.status === 405) &&
    contentType.includes("text/html")
  ) {
    response = await fetchWithAuth(reportUrl, { method: "GET" }, navigate);
  }

  if (modernEdition && response.headers?.get?.("x-soccertycs-report-edition") !== "modern") {
    throw new Error("La nueva edición todavía no está disponible en esta API");
  }
  await downloadReportResponse(response, `informe-rival-${modernEdition ? "nueva-edicion-" : ""}${datos.equipo}.pptx`);
};

export const downloadReportResponse = async (response, filename) => {
  if (!response.ok) throw new Error("Error al generar el informe");
  // Convertimos la respuesta binaria a un Blob
  const blob = await response.blob();

  // Creamos un enlace temporal para descargar el archivo
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();

  // Limpieza
  link.remove();
  window.URL.revokeObjectURL(url);
};
